import { NotificationTemplates } from "@/components/settings/NotificationTemplates";

export function SettingsNotificationTemplatesPage() {
  return <NotificationTemplates />;
}
